import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { useFilterValues } from 'find-and-filter-data/search-and-filter-data/public';
import { getHideTrash } from 'find-and-filter-data/search-and-filter-schema/protected';
import { jsx as _jsx } from "react/jsx-runtime";
const TrashToggle = () => {
  const {
    filterValues,
    setFilterValue
  } = useFilterValues();
  const onChange = ({
    target: {
      checked
    }
  }) => {
    setFilterValue('hideTrash', checked);
  };
  return /*#__PURE__*/_jsx(UICheckbox, {
    checked: getHideTrash(filterValues),
    onChange: onChange,
    "data-test-id": "search-and-filtering-hide-trash",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.trash.title"
    })
  });
};
TrashToggle.displayName = 'TrashToggle';
export default TrashToggle;